import React, { Fragment, useEffect, useRef, useState } from "react";
import BreachesTab from "../BreachesTab";
import BreachHeaderText from "../BreachHeaderText";
import InfoIcon from "../../../Assets/images/icon-info-circle.svg";
import ActionCollapse from "./ActionCollapse";
import { DialogComponent } from "../../common/DialogComponent";
import BreachActionComplete from "./BreachActionComplete";
import { getBreachActionList, completeBreachAction, setActionStep } from "../../../store/service";
import { Notification } from "../../common/Notification";
import parse from "html-react-parser";
import ActionPlanInfo from "./ActionPlanInfo";
import NoActions from "./NoActions";
import NoIncompleteAction from "./NoIncompleteAction";
import BreachPagination from "../SearchBreaches/BreachPagination";
import { Link, useHistory } from "react-router-dom";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";

const internalNavs = ["/credit/lock", "/resources/downloads", "/credit/mycredit", "/identity-vault"];
function getPosition(element: any) {
    return window.pageYOffset + element.getBoundingClientRect().top;
}

function ActionPlan() {
    const history = useHistory();
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const inCompleteRef = useRef<any>([]);
    const completedRef = useRef<any>([]);
    const inCompleteListRef = useRef<any>([]);
    const [completedAction, setCompletedAction] = useState<any>(null);
    const [isActionComplete, setIsActionComplete] = useState(false);
    const [isActionInfoOpen, setIsActionInfoOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [active, setActive] = useState("");
    const [isShowAll, setIsShowAll] = useState(false);
    const [actions, setActions] = useState<any>({
        completeActions: [],
        pendingActions: [],
    });
    const [allActions, setAllActions] = useState<any>([]);
    const [actionLabel, setActionsLabel] = useState<any>({
        completeActions: [],
        pendingActions: [],
    });
    const [page, setPage] = useState(1);
    const [completeHeight, setCompleteHeight] = useState(5);
    const closeDialog = () => {
        setIsActionComplete(false);
    };

    const closeInfoDialog = () => {
        setIsActionInfoOpen(false);
    };

    const handleKeyDown = (e: { keyCode: number }) => {
        if (e.keyCode === 13) {
            setIsActionInfoOpen(true);
            window.addToDataLayer({ event: "breachIQTooltipActionPlan" });
        }
    };

    const getActionList = (isExternalLink = false) => {
        let completed: any = [];
        let incomplete: any = [];
        getBreachActionList()
            .then((res) => {
                setIsLoading(false);
                if (res.isSuccess) {
                    if (res.body && res.body.fiActionTodos) {
                        setAllActions(res.body.fiActionTodos);
                        res.body.fiActionTodos.forEach((item: any) => {
                            if (item.action.completed) {
                                completed.push(item);
                            } else {
                                incomplete.push(item);
                            }
                        });
                        setActionsLabel({
                            completeActions: completed,
                            pendingActions: incomplete,
                        });
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
            });
    };

    const handleCompleteAction = (currentActionIndex: number, externalData?: any) => {
        let fiActionIds: any = [];
        let id = 0;
        let name = "";
        if (actions.pendingActions.length) {
            actions.pendingActions[currentActionIndex]["options"].forEach((item: any) => {
                fiActionIds.push(parseInt(item.fiActionQueueId));
            });
            id = actions.pendingActions[currentActionIndex]["action"]["id"];
            name = actions.pendingActions[currentActionIndex]["action"]["name"];
        }
        let reqData = { fiActionQueueId: fiActionIds, id, name };
        setActionStep({
            actionFiQueueId: reqData.fiActionQueueId,
            actionId: reqData.id,
            actionName: reqData.name,
            actionStepLabel: externalData && externalData.label ? externalData.label : "Mark Action as Complete",
        });
        if (externalData && externalData.externalLink) {
            setIsLoading(true);
            if (page !== 1) {
                getActionList(true);
            } else {
                getActionList();
            }
            window.open(externalData.externalLink, "_blank");
        } else if (externalData && externalData.internalLink) {
            history.push(externalData.internalLink);
        } else {
            setIsLoading(true);
            completeBreachAction(reqData)
                .then((res) => {
                    setIsLoading(false);
                    if (res.isSuccess) {
                        setCompletedAction({ ...actions.pendingActions[currentActionIndex], currentActionIndex });
                        getActionList();
                        setIsActionComplete(true);
                        setActive("");
                        setPage(1);
                    } else {
                        Notification({
                            type: "error",
                            title: "Action Complete",
                            message: "We are facing issue to complete action, please try again later.",
                            duration: 5,
                        });
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    Notification({
                        type: "error",
                        title: "Action Complete",
                        message: "We are facing issue to complete action, please try again later.",
                        duration: 5,
                    });
                });
        }
    };

    useEffect(() => {
        setIsLoading(true);
        getActionList();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    let mathPer = "0%";

    if (actionLabel && (actionLabel.pendingActions.length || actionLabel.completeActions.length)) {
        mathPer = `${((actionLabel.completeActions.length * 100) / (actionLabel.pendingActions.length + actionLabel.completeActions.length)).toFixed(2)}%`;
    }

    useEffect(() => {
        let completed: any = [];
        let incomplete: any = [];
        const res = allActions.length ? allActions.slice(page === 1 ? 0 : (page - 1) * 5, page * 5) : [];
        if (res.length) {
            res.forEach((item: any) => {
                if (item.action.completed) {
                    completed.push(item);
                } else {
                    incomplete.push(item);
                }
            });
            setActions({
                completeActions: completed,
                pendingActions: incomplete,
            });
        }
    }, [allActions, page]);

    const handleAnimate = () => {
        setTimeout(() => {
            if (completedAction && inCompleteRef && inCompleteRef.current && inCompleteRef.current.classList) {
                inCompleteRef.current.classList.remove("anim-action-complete-none");
                inCompleteRef.current.style.setProperty("--from-top", `translateY(${completeHeight}%)`);
                if (completeHeight === 100) {
                    inCompleteRef.current.style.setProperty("--to-top", `translateY(${getPosition(completedRef.current) / 2}%)`);
                } else {
                    inCompleteRef.current.style.setProperty("--to-top", `translateY(${getPosition(completedRef.current)}%)`);
                }
                inCompleteRef.current.classList.add("anim-action-complete");
            }
            setTimeout(() => {
                if (completedAction && inCompleteRef.current.classList && completedRef && completedRef.current) {
                    inCompleteRef.current.classList.remove("anim-action-complete");
                    inCompleteRef.current.classList.add("anim-action-complete-none");
                    completedRef.current.classList.add("complete-action-bg");
                    setCompletedAction(null);
                    setCompleteHeight(0);
                }
                setTimeout(() => {
                    if (completedRef && completedRef.current) {
                        completedRef.current.classList.remove("complete-action-bg");
                    }
                }, 1100);
            }, 1000);
        }, 1000);
    };

    const newCompleteActions =
        !isShowAll && actionLabel && actionLabel.completeActions.length ? actionLabel.completeActions.slice(0, 5) : actionLabel.completeActions;

    const parseLinkOption = {
        replace: (option: any) => {
            if (option.attribs && option.attribs.href) {
                const filterLink = internalNavs.find((item: string) => option.attribs.href.includes(item));
                if (filterLink) {
                    return (
                        <Link to={filterLink} className="default_link">
                            {option.children[0].data}
                        </Link>
                    );
                }
            }
        },
    };

    const takeActionOptions = {
        replace: (option: any) => {
            if (option.type === "text") {
                return <div>{parse(convertLinks(option.data), parseLinkOption)}</div>;
            }
            if (option && option.name === "ol" && option.children && option.children.length > 0) {
                return (
                    <ol style={{ listStyle: "inside", padding: "10px 0px" }}>
                        {option.children.map((item: any, i: number) =>
                            item.name === "li" ? <li key={i}>{item.children[0] && parse(convertLinks(item.children[0].data), parseLinkOption)}</li> : null
                        )}
                    </ol>
                );
            }
            if (option && option.name === "ul" && option.children && option.children.length > 0) {
                return (
                     <ol style={{ listStyle: "inside", padding: "10px 0px" }}>
                        {option.children.map((item: any, i: number) =>
                            item.name === "li" ? <li key={i}>{item.children[0] && parse(convertLinks(item.children[0].data), parseLinkOption)}</li> :
                                item.name === "ul" ?
                                    <ol style={{ listStyle: "inside", padding: "10px 30px" }}>
                                        {item.children.map((subitem: any, i: number) =>
                                            subitem.name === "li" ? <li key={i}>{subitem.children[0] && parse(convertLinks(subitem.children[0].data), parseLinkOption)}</li>: null
                                        )}
                                    </ol>
                                : null
                        )}
                    </ol>
                );
            }
        },
    };

    const convertLinks = (str: string) => {
        const regex = /\[([^\]]+)\]\((https?:\/\/[^\s\)]+)\)/g;
        let match;
        let result = str;
        let offset = 0;

        while ((match = regex.exec(str)) !== null) {
            const text = match[1];
            const link = match[2];
            const matchIndex = match.index;
            const startIndex = matchIndex + offset--;
            const endIndex = startIndex + match[0].length;
            result = `${result.substring(0, startIndex)}<a href="${link}" target="_blank">${text}</a>${result.substring(endIndex)}`;
            offset += `<a href="${link}" target="_blank" >${text}</a>`.length - match[0].length;
        }

        return result;
    };

    const additionalOption = {
        replace: (option: any) => {
            if (option.type === "text") {
                return <div>{parse(convertLinks(option.data), parseLinkOption)}</div>;
            }
        },
    };
    const renderContent = (v: any, index: number) => {
        const { content = {}, actionStepsDetails } = v;
        return (
            <div className="pending-action">
                {content && content.description && (
                    <div className="content-title">
                        <span style={{ fontSize: "1.125rem", marginRight: "0.5rem" }}>
                            <RenderIcons iconName="question-circle" />
                        </span>
                        <h5>What is this?</h5>
                    </div>
                )}
                {content && content.description && <div className="content-desc">{parse(content.description, {})}</div>}
                {content && content.image && (
                    <div className="content-desc">
                        <img src={content.image} alt="content-img" style={{ maxHeight: "120px" }} />
                    </div>
                )}
                {content && content.takeAction && (
                    <div>
                        <div className="content-title" style={{ marginBottom: 8 }}>
                            <span style={{ fontSize: "1.125rem", marginRight: "0.5rem" }}>
                                <RenderIcons iconName="clipboard-list" />
                            </span>
                            <h5>How to take this action:</h5>
                        </div>
                        <div className="content-action">{parse(content.takeAction, takeActionOptions)}</div>
                    </div>
                )}
                <button
                    className="btn-default btn-primary content-btn"
                    onClick={() => {
                        window.addToDataLayer({ event: "breachIQBtnActionStep" });
                        if (actionStepsDetails && actionStepsDetails.externalLink) {
                            handlePendingAction(index, {
                                externalLink: actionStepsDetails.externalLink,
                                label: actionStepsDetails.actionLabel,
                            });
                        } else if (actionStepsDetails && actionStepsDetails.internalLink) {
                            handlePendingAction(index, {
                                internalLink: actionStepsDetails.internalLink,
                                label: actionStepsDetails.actionLabel,
                            });
                        } else {
                            handlePendingAction(index);
                        }
                    }}
                >
                    {actionStepsDetails && actionStepsDetails.actionLabel ? actionStepsDetails.actionLabel || "Mark Action as Complete" : "Mark Action as Complete"}
                </button>
                {content && content.additionalResource && (
                    <div>
                        <div className="data-grid has-lines"></div>
                        <div className="content-title" style={{ marginBottom: 11, marginTop: " 1rem" }}>
                            <span style={{ fontSize: "1.125rem", marginRight: "0.5rem" }}>
                                <RenderIcons iconName="link" />
                            </span>
                            <h5>Additional Resources:</h5>
                        </div>
                        {content.additionalResource.map((item: string, i: number) => (
                            <div key={i}>{parse(item, additionalOption)}</div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    const handlePendingAction = (
        currentAction: any,
        externalLink?: {
            label: string;
            externalLink?: string;
            internalLink?: string;
        }
    ) => {
        if (inCompleteListRef && inCompleteListRef.current && inCompleteListRef.current[currentAction]) {
            const currentPosition = getPosition(inCompleteListRef.current[currentAction]);
            if (currentAction === 0) {
                setCompleteHeight(100);
            } else if (currentAction % 5 === 0) {
                setCompleteHeight(100);
            } else if (page > 1) {
                setCompleteHeight(currentPosition + 50);
            } else {
                setCompleteHeight(currentPosition);
            }
        }
        handleCompleteAction(currentAction, externalLink);
    };

    return (
        <Fragment>
            <div className="row">
                <BreachHeaderText />
            </div>

            <BreachesTab selectedTab="3" />

            <div className="row" id="content">
                <div className="col-xs-12 col-sm-12">
                    <div className={isLoading ? "loading box" : "box"}>
                        <div className="box-header padding-left-5rem">
                            <div className="box-title-container">
                                <div className="box-title-icon action-bulb-icon-main flex" aria-hidden="true" style={{ display: "flex" }}>
                                    <RenderIcons iconName="breach-bulb" />
                                </div>
                                <div className="box-title-text" style={{ paddingTop: 3 }}>
                                    <h2 className="breach-section-title">
                                        Your BreachIQ
                                        <span className="breach-sup-text">TM</span> Action Plan
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-description" style={{ position: "relative" }}>
                            <span className="saved-title">
                                <span
                                    role="button"
                                    onClick={() => {
                                        setIsActionInfoOpen(true);
                                        window.addToDataLayer({ event: "breachIQTooltipActionPlan" });
                                    }}
                                    tabIndex={0}
                                    onKeyDown={handleKeyDown}
                                    id="action-plan-info-span"
                                >
                                    <img
                                        src={InfoIcon}
                                        style={{ width: "1.5rem", cursor: "pointer" }}
                                        alt="Circle with the letter 'i' in the center, signifying information"
                                        id="action-plan-info-btn"
                                    />
                                </span>

                                <span className="breach-action-plan-heading breach-action-collapse-label">
                                    <span className="padding-left-xs">Open Actions</span>
                                    <span className="pending-action-color">({actionLabel.pendingActions.length})</span>
                                </span>
                            </span>
                            <div className="row breach-action-container">
                                <div className="col-xs-12">
                                    <p className="padding-bottom-xs">Complete open actions to improve your ID Safety score.</p>
                                </div>
                            </div>
                        </div>
                        {actions.pendingActions.length || actionLabel.completeActions.length ? (
                            <>
                                <div className="box-content">
                                    {actions.pendingActions.length ? (
                                        <>
                                            <ActionCollapse
                                                headers={
                                                    actions && actions.pendingActions.length
                                                        ? actions.pendingActions.map((v: any, i: number) => (
                                                            <div ref={(el) => (inCompleteListRef.current[i] = el)} key={`${i}:${v.action.id}`}>
                                                                {v.action.name}
                                                            </div>
                                                        ))
                                                        : []
                                                }
                                                btnIcon="action-btn-icon-padding"
                                                iconStyle="action-btn-icon-size"
                                                active={active}
                                                setActive={setActive}
                                            >
                                                {actions && actions.pendingActions.length
                                                    ? actions.pendingActions.map((v: any, index: number) => (
                                                        <div key={v.action.id}>{renderContent(v.action, index)}</div>
                                                    ))
                                                    : null}
                                            </ActionCollapse>

                                            <div className="breach-paging-container">
                                                <BreachPagination
                                                    pageSize={5}
                                                    currentPageNo={page}
                                                    onChange={(val: number) => {
                                                        setPage(val);
                                                        setActive("");
                                                    }}
                                                    numberOfRecord={actionLabel && actionLabel.pendingActions.length}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <NoIncompleteAction />
                                    )}

                                    {actionLabel && actionLabel.completeActions.length > 0 && (
                                        <div className="row breach-action-collapse-label">
                                            <span>Completed Actions</span>
                                        </div>
                                    )}

                                    {actionLabel && actionLabel.completeActions.length
                                        ? newCompleteActions.map((item: any, i: number) => (
                                            <div className="row breach-action-complete-bg" key={item.action.id} ref={i === 0 ? completedRef : null}>
                                                <div className="col-xs-12 display-flex-item-center text-align-center">
                                                    <div className="breach-action-complete-label">
                                                        <span className="onboarding-task-icon" style={{ fontSize: 20 }}>
                                                            <em className="las la-check-circle breach-action-complete-icon"></em>
                                                        </span>
                                                        <div className="breach-pending-title" style={{ paddingLeft: "0.5rem", textAlign: "start" }}>
                                                            {item.action ? item.action.name : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        : null}
                                    {actionLabel && actionLabel.completeActions.length > 5 && (
                                        <Link
                                            to="/"
                                            className="default_link"
                                            style={{ padding: "5px" }}
                                            onClick={(e: any) => {
                                                e.preventDefault();
                                                setIsShowAll(!isShowAll);
                                            }}
                                        >
                                            {isShowAll ? "Show fewer" : "Show all"}
                                        </Link>
                                    )}
                                </div>
                            </>
                        ) : !isLoading ? (
                            <NoActions />
                        ) : null}
                    </div>
                </div>
            </div>

            <div className="risk-rating-dialog">
                {isActionInfoOpen && (
                    <DialogComponent dialogId="dialog-action-complete" title="Breach Action Info" closeDialog={closeInfoDialog}>
                        <ActionPlanInfo closeDialog={closeInfoDialog} />
                    </DialogComponent>
                )}
            </div>

            {isActionComplete && (
                <DialogComponent
                    dialogId="dialog-action-complete"
                    title="Breach Action Complete"
                    closeDialog={() => {
                        closeDialog();
                        handleAnimate();
                    }}
                >
                    <BreachActionComplete
                        closeDialog={() => {
                            closeDialog();
                            handleAnimate();
                        }}
                    />
                </DialogComponent>
            )}
        </Fragment>
    );
}

export default ActionPlan;
